<template>
  <div class="right-block-navigation ml-auto align-items-center justify-content-end">
    <slot name="start" />
    <router-link :to="{ name: 'home', params: { lang: $store.state.ui.storeViewCode } }" class="btn btn-icon btn-icon-small btn-rounded btn-icon-border-black nav-item">
      <svg class="o-icon fill-black"><use xlink:href="#home"></use></svg>
    </router-link>
    <slot name="between" />
    <cart-badge class="nav-item" @clicked="$emit('clicked')" />
    <slot name="end" />
  </div>
</template>

<script>
import CartBadge from 'theme/components/Header/CartBadge'

export default {
  name: 'RightBlockNav',
  components: {
    CartBadge
  }
}
</script>
